import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-content',
	templateUrl:'./WaPageContentProPage.html',
	styles: [],
	styleUrls:['./WaPageContentProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageContentProPage
{
	mdContent_382 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageContent;
\`\`\``;
	mdContent_383 = `\`\`\`java
new WaPageContent<>()
\`\`\``;
}
